import React from 'react';
import {
  Row,
  Col,
  Panel,
  Form,
  FormControl,
  FormGroup,
  Button,
  DropdownButton,
  MenuItem,
  ControlLabel,
  HelpBlock,
  Checkbox,
  Radio,
  InputGroup,
  Glyphicon,
} from 'react-bootstrap';

function FieldGroup({ id, label, help, ...props }) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  );
}

class FormGeneralPage extends React.Component {
  render() {
    return (
      <div className="content-wrapper">
        <section className="content-header">
          <h1>
            General Form Elements
            <small>Control panel</small>
          </h1>
          <ol className="breadcrumb">
            <li>
              <a>
                <i className="fa fa-dashboard" /> Home
              </a>
            </li>
            <li>
              <a>Forms</a>
            </li>
            <li className="active">General Elements</li>
          </ol>
        </section>

        <section className="content">
          <Row>
            <Col md={6}>
              <Panel header="Forms">
                <form>
                  <FieldGroup
                    id="formControlsText"
                    type="text"
                    label="Text"
                    placeholder="Enter text"
                  />
                  <FieldGroup
                    id="formControlsEmail"
                    type="email"
                    label="Email address"
                    placeholder="Enter email"
                  />
                  <FieldGroup
                    id="formControlsPassword"
                    label="Password"
                    type="password"
                  />
                  <FieldGroup
                    id="formControlsFile"
                    type="file"
                    label="File"
                    help="Example block-level help text here."
                  />

                  <Checkbox checked readOnly>
                    Checkbox
                  </Checkbox>
                  <Radio checked readOnly>
                    Radio
                  </Radio>

                  <FormGroup>
                    <Checkbox inline>1</Checkbox> <Checkbox inline>2</Checkbox>{' '}
                    <Checkbox inline>3</Checkbox>
                  </FormGroup>
                  <FormGroup>
                    <Radio name="radioGroup" inline>
                      1
                    </Radio>{' '}
                    <Radio name="radioGroup" inline>
                      2
                    </Radio>{' '}
                    <Radio name="radioGroup" inline>
                      3
                    </Radio>
                  </FormGroup>

                  <FormGroup controlId="formControlsSelect">
                    <ControlLabel>Select</ControlLabel>
                    <FormControl componentClass="select" placeholder="select">
                      <option value="select">select</option>
                      <option value="other">...</option>
                    </FormControl>
                  </FormGroup>
                  <FormGroup controlId="formControlsSelectMultiple">
                    <ControlLabel>Multiple select</ControlLabel>
                    <FormControl componentClass="select" multiple>
                      <option value="select">select (multiple)</option>
                      <option value="other">...</option>
                    </FormControl>
                  </FormGroup>

                  <FormGroup controlId="formControlsTextarea">
                    <ControlLabel>Textarea</ControlLabel>
                    <FormControl
                      componentClass="textarea"
                      placeholder="textarea"
                    />
                  </FormGroup>

                  <FormGroup>
                    <ControlLabel>Static text</ControlLabel>
                    <FormControl.Static>email@example.com</FormControl.Static>
                  </FormGroup>
                </form>
              </Panel>

              <Panel header="Validations">
                <form>
                  <FormGroup
                    controlId="formValidationSuccess1"
                    validationState="success"
                  >
                    <ControlLabel>Input with success</ControlLabel>
                    <FormControl type="text" />
                    <HelpBlock>Help text with validation state.</HelpBlock>
                  </FormGroup>

                  <FormGroup
                    controlId="formValidationWarning1"
                    validationState="warning"
                  >
                    <ControlLabel>Input with warning</ControlLabel>
                    <FormControl type="text" />
                  </FormGroup>

                  <FormGroup
                    controlId="formValidationError1"
                    validationState="error"
                  >
                    <ControlLabel>Input with error</ControlLabel>
                    <FormControl type="text" />
                  </FormGroup>

                  <FormGroup
                    controlId="formValidationNull"
                    validationState={null}
                  >
                    <ControlLabel>Input with no validation state</ControlLabel>
                    <FormControl type="text" />
                  </FormGroup>

                  <FormGroup
                    controlId="formValidationSuccess2"
                    validationState="success"
                  >
                    <ControlLabel>
                      Input with success and feedback icon
                    </ControlLabel>
                    <FormControl type="text" />
                    <FormControl.Feedback />
                  </FormGroup>

                  <FormGroup
                    controlId="formValidationWarning2"
                    validationState="warning"
                  >
                    <ControlLabel>
                      Input with warning and feedback icon
                    </ControlLabel>
                    <FormControl type="text" />
                    <FormControl.Feedback />
                  </FormGroup>

                  <FormGroup
                    controlId="formValidationError2"
                    validationState="error"
                  >
                    <ControlLabel>
                      Input with error and feedback icon
                    </ControlLabel>
                    <FormControl type="text" />
                    <FormControl.Feedback />
                  </FormGroup>

                  <FormGroup
                    controlId="formValidationSuccess3"
                    validationState="success"
                  >
                    <ControlLabel>
                      Input with success and custom feedback icon
                    </ControlLabel>
                    <FormControl type="text" />
                    <FormControl.Feedback>
                      <Glyphicon glyph="music" />
                    </FormControl.Feedback>
                  </FormGroup>

                  <FormGroup
                    controlId="formValidationWarning3"
                    validationState="warning"
                  >
                    <ControlLabel>Input group with warning</ControlLabel>
                    <InputGroup>
                      <InputGroup.Addon>@</InputGroup.Addon>
                      <FormControl type="text" />
                    </InputGroup>
                    <FormControl.Feedback />
                  </FormGroup>

                  <Form componentClass="fieldset" horizontal>
                    <FormGroup
                      controlId="formValidationError3"
                      validationState="error"
                    >
                      <Col componentClass={ControlLabel} xs={3}>
                        Input with error
                      </Col>
                      <Col xs={9}>
                        <FormControl type="text" />
                        <FormControl.Feedback />
                      </Col>
                    </FormGroup>

                    <FormGroup
                      controlId="formValidationSuccess4"
                      validationState="success"
                    >
                      <Col componentClass={ControlLabel} xs={3}>
                        Input group with success
                      </Col>
                      <Col xs={9}>
                        <InputGroup>
                          <InputGroup.Addon>@</InputGroup.Addon>
                          <FormControl type="text" />
                        </InputGroup>
                        <FormControl.Feedback />
                      </Col>
                    </FormGroup>
                  </Form>

                  <Form componentClass="fieldset" inline>
                    <FormGroup
                      controlId="formValidationWarning4"
                      validationState="warning"
                    >
                      <ControlLabel>Input with warning</ControlLabel>{' '}
                      <FormControl type="text" />
                      <FormControl.Feedback />
                    </FormGroup>{' '}
                    <FormGroup
                      controlId="formValidationError4"
                      validationState="error"
                    >
                      <ControlLabel>Input group with error</ControlLabel>{' '}
                      <InputGroup>
                        <InputGroup.Addon>@</InputGroup.Addon>
                        <FormControl type="text" />
                      </InputGroup>
                      <FormControl.Feedback />
                    </FormGroup>
                  </Form>

                  <Checkbox validationState="success">
                    Checkbox with success
                  </Checkbox>
                  <Radio validationState="warning">Radio with warning</Radio>
                  <Checkbox validationState="error">
                    Checkbox with error
                  </Checkbox>

                  {/* This requires React 15's <span>-less spaces to be exactly correct. */}
                  <FormGroup validationState="success">
                    <Checkbox inline>Checkbox</Checkbox>{' '}
                    <Checkbox inline>with</Checkbox>{' '}
                    <Checkbox inline>success</Checkbox>
                  </FormGroup>
                </form>
              </Panel>
            </Col>
            <Col md={6}>
              <Panel header="Inline Form">
                <Form inline>
                  <FormGroup controlId="formInlineName">
                    <ControlLabel>Name</ControlLabel>{' '}
                    <FormControl type="text" placeholder="Jane Doe" />
                  </FormGroup>{' '}
                  <FormGroup controlId="formInlineEmail">
                    <ControlLabel>Email</ControlLabel>{' '}
                    <FormControl
                      type="email"
                      placeholder="jane.doe@example.com"
                    />
                  </FormGroup>{' '}
                  <Button type="submit">Send invitation</Button>
                </Form>
              </Panel>

              <Panel header="Horizontal Form">
                <Form horizontal>
                  <FormGroup controlId="formHorizontalEmail">
                    <Col componentClass={ControlLabel} sm={2}>
                      Email
                    </Col>
                    <Col sm={10}>
                      <FormControl type="email" placeholder="Email" />
                    </Col>
                  </FormGroup>

                  <FormGroup controlId="formHorizontalPassword">
                    <Col componentClass={ControlLabel} sm={2}>
                      Password
                    </Col>
                    <Col sm={10}>
                      <FormControl type="password" placeholder="Password" />
                    </Col>
                  </FormGroup>

                  <FormGroup>
                    <Col smOffset={2} sm={10}>
                      <Checkbox>Remember me</Checkbox>
                    </Col>
                  </FormGroup>

                  <FormGroup>
                    <Col smOffset={2} sm={10}>
                      <Button type="submit">Sign in</Button>
                    </Col>
                  </FormGroup>
                </Form>
              </Panel>

              <Panel header="Input Addons">
                <form>
                  <FormGroup>
                    <InputGroup>
                      <InputGroup.Addon>@</InputGroup.Addon>
                      <FormControl type="text" />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" />
                      <InputGroup.Addon>.00</InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                  <FormGroup>
                    <InputGroup>
                      <InputGroup.Addon>$</InputGroup.Addon>
                      <FormControl type="text" />
                      <InputGroup.Addon>.00</InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" />
                      <InputGroup.Addon>
                        <Glyphicon glyph="music" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <InputGroup>
                      <InputGroup.Button>
                        <Button>Before</Button>
                      </InputGroup.Button>
                      <FormControl type="text" />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" />
                      <DropdownButton
                        componentClass={InputGroup.Button}
                        id="input-dropdown-addon"
                        title="Action"
                      >
                        <MenuItem key="1">Item</MenuItem>
                      </DropdownButton>
                    </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <InputGroup>
                      <InputGroup.Addon>
                        <input type="radio" aria-label="..." />
                      </InputGroup.Addon>
                      <FormControl type="text" />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup>
                    <InputGroup>
                      <InputGroup.Addon>
                        <input type="checkbox" aria-label="..." />
                      </InputGroup.Addon>
                      <FormControl type="text" />
                    </InputGroup>
                  </FormGroup>
                </form>
              </Panel>

              <Panel header="Input Sizes">
                <form>
                  <FormGroup bsSize="large">
                    <FormControl type="text" placeholder="Large text" />
                  </FormGroup>
                  <FormGroup>
                    <FormControl type="text" placeholder="Normal text" />
                  </FormGroup>
                  <FormGroup bsSize="small">
                    <FormControl type="text" placeholder="Small text" />
                  </FormGroup>
                </form>
              </Panel>
            </Col>
          </Row>
        </section>
      </div>
    );
  }
}

FormGeneralPage.displayName = 'FormGeneralPage';

FormGeneralPage.defaultProps = {};

export default FormGeneralPage;



// WEBPACK FOOTER //
// ./src/pages/FormGeneralPage.js